enum CurrentEnrollmentStatus {
    Cancelled = 'CA',
    DisEnrolledbyCms = 'DC',
    Disenrolled = 'DE',
    Denied = 'DN',
    DisenrollmentPending = 'DP',
    Eligible = 'EL',
    Enrolled = 'EN',
    EnrollmentPending = 'EP',
    EnrollmentRejected = 'ER',
    EnrollmentSentToCms = 'ES',
    InvoluntaryDisenrolled = 'ID',
    Ineligible = 'IE',
    PendingDenial = 'PD',
    Pending = 'PE',
    SendEnrollmentToCms = 'SE',
    VoluntaryDisenrolled = 'VD',
}

export default CurrentEnrollmentStatus;
